const specialChars = ["¢", "£", "¥", "€", "©", "®", "<", ">", '"', "&", "'"];

function contains(text: string) {
  for (const char of specialChars) {
    if (text.includes(char)) {
      return true;
    }
  }
  return false;
}

export function wrap(text: string) {
  // "]]>" in the text would end the CDATA section early, so it's split across two sections
  return contains(text)
    ? `<![CDATA[${text.replaceAll("]]>", "]]]]><![CDATA[>")}]]>`
    : text;
}
